import React from "react";
import EntityForm from "../../EntityForm/EntityForm";
import "./customStyles.css";
import { entityToFormValuesMapper } from "../../../Common/utils";
import { QuestionnaireFormContext } from "../QuestionnaireFormContext";

// Answer types allowed per form kind; other depender types keep all types.
const GUEST_LIKE_WIDGET_TYPES = ["INPUT", "SELECT", "STAY_DATE", "PHONE"];
const ALLOWED_WIDGET_TYPES_BY_DEPENDER = {
  ROOMSTAY_CHECKOUT: ["INPUT", "RADIO", "SELECT", "CHECKBOX"],
  GUEST_FORM: GUEST_LIKE_WIDGET_TYPES,
  CANCELLATION_FORM: GUEST_LIKE_WIDGET_TYPES,
};

function restrictWidgetTypesForDepender(formFields, dependerType) {
  const allowed = ALLOWED_WIDGET_TYPES_BY_DEPENDER[dependerType];
  if (!allowed || !Array.isArray(formFields)) return formFields;
  return formFields.map(field => {
    if (field.fieldName !== "widgetType" || !field.optionDisplay) return field;
    const optionDisplay = Object.fromEntries(
      Object.entries(field.optionDisplay).filter(([type]) => allowed.includes(type))
    );
    return { ...field, optionDisplay };
  });
}

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });

  return { ...formValues };
}

class NestedQuestionnairesForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit = ({ formValues }) => {
    const { id, ...otherFormValues } = formValues;

    const entity = otherFormValues;

    if (id !== "" && id !== " " && id !== null && typeof formValues.id !== "undefined") {
      entity.id = formValues.id;
    }

    this.props.onSubmitEntity({
      entity,
    });
  };

  render() {
    const { config } = this.props;
    const { name, validation, fields, renderers, translation, entities } = config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      loading,
      getListPath,
      nested,
      afterSubmit,
      onCancelEdit,
    } = this.props;
    const { getFields, handleSubmit } = this;
    const dependerType = this.context && this.context.currentDependerType;
    const formFields = restrictWidgetTypesForDepender(getFields(fields), dependerType);
    return (
      <div className={"wbkv9-form-nestedQuestionnaire"}>
        <EntityForm
          loading={loading}
          name={name}
          entity={entity}
          entities={entities}
          validation={validation}
          renderers={renderers}
          fields={formFields}
          locales={locales}
          translation={translation}
          onSubmit={handleSubmit}
          entityError={entityError}
          entityResult={entityResult}
          getListPath={getListPath}
          nested={nested}
          afterSubmit={afterSubmit}
          onCancelEdit={onCancelEdit}
          customEntityToFormValuesMapper={customEntityToFormValuesMapper}
        />
      </div>
    );
  }
}

NestedQuestionnairesForm.contextType = QuestionnaireFormContext;

NestedQuestionnairesForm.propTypes = {};

NestedQuestionnairesForm.defaultProps = {};

export default NestedQuestionnairesForm;
